module.exports = __webpack_public_path__ + "img/logo_reg_serv.fce6060b.png";